import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy
} from '@angular/core';

import { DateParserService } from '../../../core/services/date-parser.service';

declare var $: any;

/**
 * Replaces the AngularJS "date" directive that used to initialise
 * bootstrap-datepicker on `.input-group-addon.date` spans.
 *
 * For `type="text"` inputs it attaches the jQuery bootstrap-datepicker
 * plugin so the calendar button opens a dropdown picker.
 *
 * For `type="date"` / `type="time"` inputs it opens the browser's
 * native picker via `showPicker()`.
 */
@Directive({
  selector: '.input-group-addon.date'
})
export class DatePickerButtonDirective implements AfterViewInit, OnDestroy {

  private input: HTMLInputElement | null = null;
  private clickHandler: (() => void) | null = null;

  constructor (
    private el          : ElementRef,
    private dateParsing : DateParserService
  ) {}

  ngAfterViewInit () : void {
    const span: HTMLElement = this.el.nativeElement;
    this.input = span.parentElement?.querySelector('input') || null;

    if (!this.input) {
      return;
    }

    const type = this.input.type;

    if (type === 'date' || type === 'time') {
      this.clickHandler = () => {
        try {
          (this.input as any).showPicker();
        } catch {
          this.input!.focus();
        }
      };

      span.addEventListener('click', this.clickHandler);
    } else {
      $(span).datepicker({
        autoclose: true,
        format   : this.dateParsing.getFormat(),
        todayBtn : 'linked'
      })
      .on('changeDate', (e: any) => {
        // Bootstrap datepicker DST bug workaround — add one hour.
        e.date.setTime(e.date.getTime() + 1 * 60 * 60 * 1000);

        const date  = e.date.getDate();
        const month = e.date.getMonth() + 1;
        const year  = e.date.getFullYear();

        const formatted = this.dateParsing.getFormat()
          .replace('dd', date)
          .replace('mm', month)
          .replace('yyyy', year);

        $(this.input).val(formatted).trigger('input');
      });
    }
  }

  ngOnDestroy () : void {
    if (this.clickHandler) {
      this.el.nativeElement.removeEventListener('click', this.clickHandler);
    }
  }
}
